import React from "react";
import './index.less'
import moment from "moment";

export default function () {
  const formatterDate = (val) => {
    return val ? moment(val).format('YYYY-MM-DD HH:mm') : '';
  }

  return [
    {
      title: '业务名称',
      name: 'name',
      tableItem: {
      }
    },
    {
      title: '业务编码',
      name: 'scoId',
      tableItem: {

      }
    },
    {
      title: '业务',
      name: '',
      tableItem: {
        width: 120,
        render: (text, record, index) => <span>在线课程</span>
      }
    },
    {
      title: '业务时间',
      name: 'startDate',
      tableItem: {
        width: 300,
        render: (text, record, index) => <span>{formatterDate(text)}~{formatterDate(record.endDate)}</span>
      }
    },
    {
      title: '状态',
      name: 'status',
      tableItem: {
        width: 150,
        render: (text, record, index) => {
          return (
            <span>已发布</span>
          )
        }
      },
    },
  ]
}
